const rpStatuses = {
  Nuevo_y_ReCoordinar_Cita: -1,
  UnSet: 0,
  Nuevo: 1,
  Cita_Coordinada: 3,
  Denegado: 4, // Now the name is Canceled,
  //TODO: Change the name to Canceled in the rest of the files
  Cancelado: 4,
  Procesado: 5,
  Aprobado: 6,
  ReCoordinar_Cita: 7,
  Referido_a_Remedio_Provisional: 8,
  Inactivo: 9,
  AprobadoEnRempro: 10,
  Evaluado: 11,
  No_Vinculado_Devuelto_RemPro: 12,
  AprobadoDevueltoREMPRO: 14,
};

export default rpStatuses;
